import { getAppUrlInfo } from "../utils/urls";

 
const {apiUrl} =  getAppUrlInfo();

export const ACCOUNTS_API_PATHS = {
  // 👤 Users
  // Users
  users: `${apiUrl}/users`, 
  userId: (id: string | number) => `${apiUrl}/users/${id}`, 
  usersBatchCreate: `${apiUrl}/users/batch-create`, 

  // 🛡️ Roles
  roles: `${apiUrl}/roles`, 
  roleId: (id: string | number) => `${apiUrl}/roles/${id}`, 
  rolesBatchCreate: `${apiUrl}/roles/batch-create`, 
 
  // 📚 Masters
  usersMasterData: `${apiUrl}/masters/users`,
  rolesMasterData: `${apiUrl}/masters/roles`, 


  // 👤 Auth
  userLogin: `${apiUrl}/auth/login`,
  userLogout: `${apiUrl}/auth/logout`, 
  refreshToken: `${apiUrl}/auth/refresh`, 
  resetPassword: `${apiUrl}/auth/reset-password`, 
  sendTemporaryPasswordEmail: `${apiUrl}/auth/send-temporary-password`,  

  //History
  loginHistoryByUserId: (id: string | number) => `${apiUrl}/auth/login-history/${id}`, 
  passwordHistoryByUserId: (id: string | number) => `${apiUrl}/auth/password-history/${id}`, 

  // 💰 Expenses
  expenses: `${apiUrl}/expenses`, 
  expensesId: (id: string | number) => `${apiUrl}/expenses/${id}`,
  expensesBatchCreate: `${apiUrl}/expenses/batch-create`,
  expensesCategoryCombinations: `${apiUrl}/expenses/category-combinations`,

  // 📄 Documents
  documents: `${apiUrl}/documents`,
  documentsId: (id: string | number) => `${apiUrl}/documents/${id}`,
};
